import TextBox from "../../../../../../../common/components/molecule/TextBox/TextBox";


export default function PoleNameView({name}:{name?: string}) {
  return (
    <TextBox variant='dark' content={[{
        title: 'Poteau',
        text: name || 'Non renseigné'
    }]}/>
  )
}
